import { Questionnaire } from './questionnaire';
import { Client } from './client';
import {JsonObject, JsonProperty} from 'json2typescript';
// TODO: modifier pour deserealiser et serializer avec JSON2Typescript
@JsonObject('Project')
export class Project {
    @JsonProperty('id',Number)
    id = 0;

    @JsonProperty('name',String)
    name = '';

    @JsonProperty('code',String,true)
    code = '';

    @JsonProperty('type',String,true)
    type = '';

    @JsonProperty('createdDate',String)
    createdDate = '';

    @JsonProperty('lastModifiedDate',String)
    lastModifiedDate = '';

    @JsonProperty('client')
    client: Client = new Client() ; // nom du client

    @JsonProperty('questionnaires',[Questionnaire])
    questionnaires:Questionnaire[] = [];

    @JsonProperty('isSelected',Boolean)
    isSelected = false;

    @JsonProperty('tags',[String])
    tags:string[] = [];

    @JsonProperty('webProject',Boolean)
    webProject = false;
   // constructor(json:any) {
        /*if (json != null) {
            this.type = json.type;
            this.id = json.id;
            this.name = json.name;
            this.code = json.code;
            this.createdDate = json.createdDate;
            this.lastModifiedDate = json.lastModifiedDate;
            this.webProject = json.webProject;


            if (json.tags != null) {
                for (const tag of json.tags) {
                    this.tags.push(tag);
                }
            }

            if (json.client != null) {
                this.client.id = json.client.id;
                this.client.name = json.client.name;
                this.client.password = json.client.password;
                this.client.username = json.client.username;
            }

            this.questionnaires = new Array<Questionnaire>();

            if (json.questionnaires != null) {
                for (let i = 0; i < json.questionnaires.length; i++) {
                    this.questionnaires.push(new Questionnaire(json.questionnaires[i]));
                }
            }
        }*/


   // }

 }

